import React from "react";
import "../../../css/DesignSystem/Buttons/SignInButton.css";

const SignInButton = ({ imgSrc, title, onClick }) => {
  return (
    <div className="SignInButton-Container" onClick={onClick}>
     {imgSrc && <img src={imgSrc} alt="icon" />}
      <div className="Content-Large">{title}</div>
    </div>
  );
};
export default SignInButton;
